import React, { useState } from 'react';
import { SearchIcon, FilterIcon, MapIcon, ListIcon, EyeIcon, TrashIcon, CalendarIcon, DollarSignIcon, UserIcon, MapPinIcon, MessageSquareIcon, XIcon, CheckIcon, RefreshCwIcon, AlertTriangleIcon } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
const bookings = [{
  id: '1410',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Ricardo',
    avatar: 'https://i.pravatar.cc/150?img=11'
  },
  address: '111 Green Gardens Boulevard',
  coordinates: [43.6532, -79.3832],
  bookingDate: '11-11-25 17:00',
  service: 'Sign Installation',
  serviceType: 'Realtor Tech & Marketing Solutions',
  status: 'accepted',
  price: 250,
  chatLogs: [{
    sender: 'customer',
    message: 'Can you arrive at 5 PM?',
    time: '10:30 AM'
  }, {
    sender: 'pro',
    message: 'Yes, I will be there at 5 PM',
    time: '10:45 AM'
  }]
}, {
  id: '1409',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Ricardo',
    avatar: 'https://i.pravatar.cc/150?img=11'
  },
  address: '111 Green Gardens Boulevard',
  coordinates: [43.6532, -79.3832],
  bookingDate: '11-11-25 17:00',
  service: 'Sign Installation',
  serviceType: 'Realtor Tech & Marketing Solutions',
  status: 'canceled',
  price: 250,
  chatLogs: []
}, {
  id: '1408',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Johnson',
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  address: '8 Jack Court',
  coordinates: [43.7615, -79.4111],
  bookingDate: '11-10-25 17:00',
  service: 'Handyman Services',
  serviceType: 'Home Services',
  status: 'bill_generated',
  price: 180,
  chatLogs: []
}, {
  id: '1407',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Johnson',
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  address: '8 Jack Court',
  coordinates: [43.7615, -79.4111],
  bookingDate: '11-07-25 17:00',
  service: 'Handyman Services',
  serviceType: 'Home Services',
  status: 'canceled',
  price: 180,
  chatLogs: []
}, {
  id: '1398',
  customer: {
    name: 'Shanton Morrison',
    avatar: 'https://i.pravatar.cc/150?img=2'
  },
  pro: {
    name: 'Shanton Morrison',
    avatar: 'https://i.pravatar.cc/150?img=2'
  },
  address: '45 Digby Crescent',
  coordinates: [43.6426, -79.3871],
  bookingDate: '11-05-25 16:22',
  service: 'Pool Inspection Service',
  serviceType: 'Home Services',
  status: 'completed',
  price: 300,
  chatLogs: []
}, {
  id: '1390',
  customer: {
    name: 'Ken Matsumoto',
    avatar: 'https://i.pravatar.cc/150?img=3'
  },
  pro: {
    name: 'Mandarin Heating & Cooling Inc',
    avatar: 'https://i.pravatar.cc/150?img=13'
  },
  address: '2173 Danforth Ave, Toronto, ON M4C 1K4, Canada',
  coordinates: [43.6895, -79.2985],
  bookingDate: '10-14-25 16:00',
  service: 'HVAC Repair & Installation',
  serviceType: 'Repairs & Maintenance',
  status: 'en_route',
  price: 450,
  chatLogs: []
}, {
  id: '1395',
  customer: {
    name: 'Kosta Deris',
    avatar: 'https://i.pravatar.cc/150?img=1'
  },
  pro: {
    name: 'Yan Staging',
    avatar: 'https://i.pravatar.cc/150?img=14'
  },
  address: '3 Darley Street',
  coordinates: [43.6629, -79.3957],
  bookingDate: '10-28-25 16:00',
  service: 'Staging/Design',
  serviceType: 'Real Estate Services',
  status: 'in_progress',
  price: 500,
  chatLogs: []
}];
export const BookingsPage = () => {
  const [viewMode, setViewMode] = useState('list');
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [serviceTypeFilter, setServiceTypeFilter] = useState('all');
  const filteredBookings = bookings.filter(booking => {
    const matchesSearch = booking.customer.name.toLowerCase().includes(searchQuery.toLowerCase()) || booking.pro.name.toLowerCase().includes(searchQuery.toLowerCase()) || booking.id.includes(searchQuery);
    const matchesStatus = statusFilter === 'all' || booking.status === statusFilter;
    const matchesServiceType = serviceTypeFilter === 'all' || booking.serviceType === serviceTypeFilter;
    return matchesSearch && matchesStatus && matchesServiceType;
  });
  return <div className="p-6 h-full flex flex-col" data-id="element-372">
      <div className="mb-6" data-id="element-373">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-374">Bookings</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-375">
          Manage and track all service bookings
        </p>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100 flex-1 flex flex-col" data-id="element-376">
        <div className="p-4 border-b border-gray-200" data-id="element-377">
          <div className="flex items-center justify-between mb-4" data-id="element-378">
            <div className="flex items-center space-x-2" data-id="element-379">
              <button className="p-2 rounded-md hover:bg-gray-100" data-id="element-380">
                <FilterIcon size={18} className="text-gray-500" data-id="element-381" />
              </button>
              <div className="relative" data-id="element-382">
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-383" />
                <input type="text" placeholder="Search bookings..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-80" data-id="element-384" />
              </div>
              <select value={serviceTypeFilter} onChange={e => setServiceTypeFilter(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-385">
                <option value="all" data-id="element-386">All Service Types</option>
                <option value="Repairs & Maintenance" data-id="element-387">
                  Repairs & Maintenance
                </option>
                <option value="Home Services" data-id="element-388">Home Services</option>
                <option value="Real Estate Services" data-id="element-389">
                  Real Estate Services
                </option>
                <option value="Realtor Tech & Marketing Solutions" data-id="element-390">
                  Realtor Tech & Marketing Solutions
                </option>
                <option value="Renovation & Improvements" data-id="element-391">
                  Renovation & Improvements
                </option>
              </select>
              <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-392">
                <option value="all" data-id="element-393">All Status</option>
                <option value="accepted" data-id="element-394">Accepted</option>
                <option value="in_progress" data-id="element-395">In Progress</option>
                <option value="en_route" data-id="element-396">En Route</option>
                <option value="completed" data-id="element-397">Completed</option>
                <option value="canceled" data-id="element-398">Canceled</option>
                <option value="bill_generated" data-id="element-399">Bill Generated</option>
              </select>
            </div>
            <div className="flex items-center space-x-2" data-id="element-400">
              <button onClick={() => setViewMode('list')} className={`p-2 rounded-md ${viewMode === 'list' ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100'}`} data-id="element-401">
                <ListIcon size={18} data-id="element-402" />
              </button>
              <button onClick={() => setViewMode('map')} className={`p-2 rounded-md ${viewMode === 'map' ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100'}`} data-id="element-403">
                <MapIcon size={18} data-id="element-404" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex-1 overflow-hidden" data-id="element-405">
          {viewMode === 'list' ? <div className="overflow-auto h-full" data-id="element-406">
              <table className="w-full" data-id="element-407">
                <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-408">
                  <tr data-id="element-409">
                    <th className="px-4 py-3 text-left" data-id="element-410">
                      <input type="checkbox" className="rounded" data-id="element-411" />
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-412">
                      ID
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-413">
                      Customer
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-414">
                      Pro
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-415">
                      Address
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-416">
                      Booking Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-417">
                      Service Type
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-418">
                      Service
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-419">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-420">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-421">
                  {filteredBookings.map(booking => <BookingRow key={booking.id} booking={booking} onViewDetails={() => setSelectedBooking(booking)} data-id="element-422" />)}
                </tbody>
              </table>
            </div> : <BookingMapView bookings={filteredBookings} data-id="element-423" />}
        </div>
      </div>
      {selectedBooking && <BookingDetailModal booking={selectedBooking} onClose={() => setSelectedBooking(null)} data-id="element-424" />}
    </div>;
};
const BookingRow = ({
  booking,
  onViewDetails
}) => {
  const getStatusBadge = status => {
    const statusConfig = {
      accepted: {
        label: 'Accepted',
        color: 'bg-cyan-500 text-white'
      },
      canceled: {
        label: 'Canceled',
        color: 'bg-red-500 text-white'
      },
      bill_generated: {
        label: 'Bill Generated',
        color: 'bg-blue-500 text-white'
      },
      completed: {
        label: 'Job Completed',
        color: 'bg-green-500 text-white'
      },
      in_progress: {
        label: 'In Progress',
        color: 'bg-cyan-400 text-white'
      },
      en_route: {
        label: 'En Route',
        color: 'bg-gray-400 text-white'
      }
    };
    const config = statusConfig[status] || statusConfig.accepted;
    return <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${config.color}`} data-id="element-425">
        {config.label}
      </span>;
  };
  return <tr className="hover:bg-gray-50" data-id="element-426">
      <td className="px-4 py-3" data-id="element-427">
        <input type="checkbox" className="rounded" data-id="element-428" />
      </td>
      <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-429">
        {booking.id}
      </td>
      <td className="px-4 py-3" data-id="element-430">
        <div className="flex items-center" data-id="element-431">
          <img src={booking.customer.avatar} alt={booking.customer.name} className="h-8 w-8 rounded-full mr-2" data-id="element-432" />
          <span className="text-sm font-medium text-gray-900" data-id="element-433">
            {booking.customer.name}
          </span>
        </div>
      </td>
      <td className="px-4 py-3" data-id="element-434">
        <div className="flex items-center" data-id="element-435">
          <img src={booking.pro.avatar} alt={booking.pro.name} className="h-8 w-8 rounded-full mr-2" data-id="element-436" />
          <span className="text-sm text-gray-900" data-id="element-437">{booking.pro.name}</span>
        </div>
      </td>
      <td className="px-4 py-3 text-sm text-gray-500 max-w-xs truncate" data-id="element-438">
        {booking.address}
      </td>
      <td className="px-4 py-3 text-sm text-gray-500" data-id="element-439">{booking.bookingDate}</td>
      <td className="px-4 py-3" data-id="element-440">
        <span className="text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded" data-id="element-441">
          {booking.serviceType}
        </span>
      </td>
      <td className="px-4 py-3" data-id="element-442">
        <div className="flex items-center" data-id="element-443">
          <span className="text-sm text-gray-900" data-id="element-444">{booking.service}</span>
        </div>
      </td>
      <td className="px-4 py-3" data-id="element-445">{getStatusBadge(booking.status)}</td>
      <td className="px-4 py-3" data-id="element-446">
        <div className="flex items-center space-x-2" data-id="element-447">
          <button onClick={onViewDetails} className="p-1 hover:bg-gray-100 rounded text-blue-600" data-id="element-448">
            <EyeIcon size={16} data-id="element-449" />
          </button>
          <button className="p-1 hover:bg-gray-100 rounded text-red-600" data-id="element-450">
            <TrashIcon size={16} data-id="element-451" />
          </button>
        </div>
      </td>
    </tr>;
};
const BookingMapView = ({
  bookings
}) => {
  return <div className="h-full w-full" data-id="element-452">
      <MapContainer center={[43.6532, -79.3832]} zoom={11} style={{
      height: '100%',
      width: '100%'
    }} data-id="element-453">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' data-id="element-454" />
        {bookings.map(booking => <Marker key={booking.id} position={booking.coordinates} data-id="element-455">
            <Popup data-id="element-456">
              <div className="p-2" data-id="element-457">
                <p className="font-semibold" data-id="element-458">{booking.service}</p>
                <p className="text-sm text-gray-600" data-id="element-459">{booking.customer.name}</p>
                <p className="text-sm text-gray-600" data-id="element-460">{booking.address}</p>
                <p className="text-sm font-medium mt-1" data-id="element-461">${booking.price}</p>
              </div>
            </Popup>
          </Marker>)}
      </MapContainer>
    </div>;
};
const BookingDetailModal = ({
  booking,
  onClose
}) => {
  const [activeTab, setActiveTab] = useState('details');
  const [activeAction, setActiveAction] = useState(null);
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-462">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-463">
        <div className="p-6 border-b border-gray-200 flex items-center justify-between" data-id="element-464">
          <div data-id="element-465">
            <h2 className="text-2xl font-bold text-gray-800" data-id="element-466">
              Booking #{booking.id}
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-467">{booking.service}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-468">
            <XIcon size={20} data-id="element-469" />
          </button>
        </div>
        <div className="border-b border-gray-200" data-id="element-470">
          <div className="flex space-x-1 px-6" data-id="element-471">
            <TabButton active={activeTab === 'details'} onClick={() => setActiveTab('details')} data-id="element-472">
              Details
            </TabButton>
            <TabButton active={activeTab === 'chat'} onClick={() => setActiveTab('chat')} data-id="element-473">
              Chat Logs
            </TabButton>
            <TabButton active={activeTab === 'actions'} onClick={() => setActiveTab('actions')} data-id="element-474">
              Admin Actions
            </TabButton>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-6" data-id="element-475">
          {activeTab === 'details' && <div className="space-y-6" data-id="element-476">
              <div className="grid grid-cols-2 gap-6" data-id="element-477">
                <div className="space-y-4" data-id="element-478">
                  <div data-id="element-479">
                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-480">
                      Customer Information
                    </h3>
                    <div className="flex items-center p-4 bg-gray-50 rounded-lg" data-id="element-481">
                      <img src={booking.customer.avatar} alt={booking.customer.name} className="h-12 w-12 rounded-full mr-3" data-id="element-482" />
                      <div data-id="element-483">
                        <p className="font-semibold text-gray-900" data-id="element-484">
                          {booking.customer.name}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-485">Customer</p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-486">
                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-487">
                      Pro Information
                    </h3>
                    <div className="flex items-center p-4 bg-gray-50 rounded-lg" data-id="element-488">
                      <img src={booking.pro.avatar} alt={booking.pro.name} className="h-12 w-12 rounded-full mr-3" data-id="element-489" />
                      <div data-id="element-490">
                        <p className="font-semibold text-gray-900" data-id="element-491">
                          {booking.pro.name}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-492">
                          Service Provider
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4" data-id="element-493">
                  <div data-id="element-494">
                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-495">
                      Location
                    </h3>
                    <div className="p-4 bg-gray-50 rounded-lg" data-id="element-496">
                      <div className="flex items-start" data-id="element-497">
                        <MapPinIcon size={20} className="text-gray-400 mr-2 mt-1" data-id="element-498" />
                        <p className="text-sm text-gray-900" data-id="element-499">
                          {booking.address}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-500">
                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-501">
                      Booking Details
                    </h3>
                    <div className="p-4 bg-gray-50 rounded-lg space-y-2" data-id="element-502">
                      <div className="flex items-center justify-between" data-id="element-503">
                        <span className="text-sm text-gray-600" data-id="element-504">
                          Date & Time
                        </span>
                        <span className="text-sm font-medium text-gray-900" data-id="element-505">
                          {booking.bookingDate}
                        </span>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-506">
                        <span className="text-sm text-gray-600" data-id="element-507">
                          Service Type
                        </span>
                        <span className="text-sm font-medium text-gray-900" data-id="element-508">
                          {booking.serviceType}
                        </span>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-509">
                        <span className="text-sm text-gray-600" data-id="element-510">Service</span>
                        <span className="text-sm font-medium text-gray-900" data-id="element-511">
                          {booking.service}
                        </span>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-512">
                        <span className="text-sm text-gray-600" data-id="element-513">Price</span>
                        <span className="text-sm font-medium text-gray-900" data-id="element-514">
                          ${booking.price}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-64 rounded-lg overflow-hidden border border-gray-200" data-id="element-515">
                <MapContainer center={booking.coordinates} zoom={15} style={{
              height: '100%',
              width: '100%'
            }} data-id="element-516">
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-517" />
                  <Marker position={booking.coordinates} data-id="element-518">
                    <Popup data-id="element-519">{booking.address}</Popup>
                  </Marker>
                </MapContainer>
              </div>
            </div>}
          {activeTab === 'chat' && <div className="space-y-4" data-id="element-520">
              {booking.chatLogs.length > 0 ? booking.chatLogs.map((log, index) => <div key={index} className={`flex ${log.sender === 'customer' ? 'justify-start' : 'justify-end'}`} data-id="element-521">
                    <div className={`max-w-md p-3 rounded-lg ${log.sender === 'customer' ? 'bg-gray-100' : 'bg-blue-500 text-white'}`} data-id="element-522">
                      <p className="text-sm" data-id="element-523">{log.message}</p>
                      <p className={`text-xs mt-1 ${log.sender === 'customer' ? 'text-gray-500' : 'text-blue-100'}`} data-id="element-524">
                        {log.time}
                      </p>
                    </div>
                  </div>) : <div className="text-center py-8 text-gray-500" data-id="element-525">
                  <MessageSquareIcon size={48} className="mx-auto mb-2 text-gray-300" data-id="element-526" />
                  <p data-id="element-527">No chat messages yet</p>
                </div>}
            </div>}
          {activeTab === 'actions' && <div className="space-y-4" data-id="element-528">
              <div className="grid grid-cols-2 gap-4" data-id="element-529">
                <button onClick={() => setActiveAction('reassign')} className="flex items-center justify-center px-4 py-3 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100" data-id="element-530">
                  <RefreshCwIcon size={20} className="mr-2" data-id="element-531" />
                  Reassign to Pro
                </button>
                <button onClick={() => setActiveAction('schedule')} className="flex items-center justify-center px-4 py-3 bg-purple-50 text-purple-600 rounded-lg hover:bg-purple-100" data-id="element-532">
                  <CalendarIcon size={20} className="mr-2" data-id="element-533" />
                  Adjust Schedule
                </button>
                <button onClick={() => setActiveAction('refund')} className="flex items-center justify-center px-4 py-3 bg-orange-50 text-orange-600 rounded-lg hover:bg-orange-100" data-id="element-534">
                  <DollarSignIcon size={20} className="mr-2" data-id="element-535" />
                  Issue Refund
                </button>
                <button onClick={() => setActiveAction('cancel')} className="flex items-center justify-center px-4 py-3 bg-red-50 text-red-600 rounded-lg hover:bg-red-100" data-id="element-536">
                  <XIcon size={20} className="mr-2" data-id="element-537" />
                  Cancel Job
                </button>
                <button className="flex items-center justify-center px-4 py-3 bg-green-50 text-green-600 rounded-lg hover:bg-green-100" data-id="element-538">
                  <CheckIcon size={20} className="mr-2" data-id="element-539" />
                  Approve Job
                </button>
              </div>
              {activeAction === 'reassign' && <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-540">
                  <h4 className="font-semibold mb-3" data-id="element-541">Reassign to New Pro</h4>
                  <select className="w-full px-3 py-2 border border-gray-300 rounded-md mb-3" data-id="element-542">
                    <option data-id="element-543">Select a Pro</option>
                    <option data-id="element-544">Ricardo</option>
                    <option data-id="element-545">Johnson</option>
                    <option data-id="element-546">Yan Staging</option>
                  </select>
                  <div className="flex space-x-2" data-id="element-547">
                    <button className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-548">
                      Confirm Reassignment
                    </button>
                    <button onClick={() => setActiveAction(null)} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-549">
                      Cancel
                    </button>
                  </div>
                </div>}
              {activeAction === 'schedule' && <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-550">
                  <h4 className="font-semibold mb-3" data-id="element-551">Adjust Schedule</h4>
                  <div className="mb-3" data-id="element-552">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-553">
                      Current Date & Time
                    </label>
                    <input type="text" value={booking.bookingDate} disabled className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 text-gray-600" data-id="element-554" />
                  </div>
                  <div className="mb-3" data-id="element-555">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-556">
                      New Date & Time
                    </label>
                    <input type="datetime-local" className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-557" />
                  </div>
                  <div className="flex space-x-2" data-id="element-558">
                    <button className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700" data-id="element-559">
                      Confirm Schedule Change
                    </button>
                    <button onClick={() => setActiveAction(null)} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-560">
                      Cancel
                    </button>
                  </div>
                </div>}
              {activeAction === 'refund' && <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-561">
                  <h4 className="font-semibold mb-3" data-id="element-562">Issue Refund</h4>
                  <div className="mb-3" data-id="element-563">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-564">
                      Refund Amount
                    </label>
                    <input type="number" defaultValue={booking.price} className="w-full px-3 py-2 border border-gray-300 rounded-md" data-id="element-565" />
                  </div>
                  <div className="mb-3" data-id="element-566">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-567">
                      Reason
                    </label>
                    <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md" rows={3} placeholder="Enter refund reason..." data-id="element-568" />
                  </div>
                  <div className="flex space-x-2" data-id="element-569">
                    <button className="flex-1 px-4 py-2 bg-orange-600 text-white rounded-md hover:bg-orange-700" data-id="element-570">
                      Process Refund
                    </button>
                    <button onClick={() => setActiveAction(null)} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-571">
                      Cancel
                    </button>
                  </div>
                </div>}
              {activeAction === 'cancel' && <div className="mt-6 p-4 bg-red-50 rounded-lg border-2 border-red-200" data-id="element-572">
                  <div className="flex items-start mb-4" data-id="element-573">
                    <AlertTriangleIcon size={24} className="text-red-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-574" />
                    <div data-id="element-575">
                      <h4 className="font-semibold text-red-900 mb-2" data-id="element-576">
                        Cancel Job Confirmation
                      </h4>
                      <p className="text-sm text-red-800 mb-3" data-id="element-577">
                        Are you sure you want to cancel this booking? This
                        action cannot be undone. The customer and pro will be
                        notified immediately.
                      </p>
                    </div>
                  </div>
                  <div className="mb-3" data-id="element-578">
                    <label className="block text-sm font-medium text-red-900 mb-1" data-id="element-579">
                      Cancellation Reason
                    </label>
                    <textarea className="w-full px-3 py-2 border border-red-300 rounded-md" rows={3} placeholder="Please provide a reason for cancellation..." data-id="element-580" />
                  </div>
                  <div className="flex space-x-2" data-id="element-581">
                    <button className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 font-medium" data-id="element-582">
                      Confirm Cancellation
                    </button>
                    <button onClick={() => setActiveAction(null)} className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100" data-id="element-583">
                      Go Back
                    </button>
                  </div>
                </div>}
            </div>}
        </div>
      </div>
    </div>;
};
const TabButton = ({
  active,
  children,
  onClick
}) => {
  return <button onClick={onClick} className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${active ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-584">
      {children}
    </button>;
};